import { EcommerceProduct } from '../interfaces/ecommerce-product.interface';
import { addProductToCart, purchaseProducts, removeLastProductFromCart, reviewProduct } from '../redux/ecommerce-slice';
import { store } from '../redux/redux-toolkit-store';

export enum EcommerceAction {
  REVIEW = 'review',
  CART = 'cart'
}

class Ecommerce {
  dispatch = store.dispatch;

  private getCart() {
    return [...store.getState().ecommerce.cart];
  }

  add(action: EcommerceAction, product: EcommerceProduct) {
    

    if (action == EcommerceAction.REVIEW) {
      this.dispatch(reviewProduct(product));
      // postMessageService.send({ event: GET_ECOMMERCE_ACTION, data: { ecommerce: { detail: { products: [product] }}}});
    }

    if (action == EcommerceAction.CART) {  
      this.dispatch(addProductToCart(product));
      // postMessageService.send({ event: GET_ECOMMERCE_ACTION, data: { ecommerce: { add: { products: [product] }}}});
    }
  }

  removeLast() {
    const cart = this.getCart();
    const last = cart.pop();

    if (last) {
      // postMessageService.send({ event: GET_ECOMMERCE_ACTION, data: { ecommerce: { remove: { products: [last] }}}});
      this.dispatch(removeLastProductFromCart());
    }
  }

  purchase(leadId: string) {
    // postMessageService.send({ event: GET_ECOMMERCE_ACTION, data: {
    //   ecommerce: {
    //     purchase: { 
    //       actionField: {
    //         id: leadId,
    //         goal_id: EVENT_GET_LEAD
    //       },
    //       products: this.getCart()
    //     }
    //   }
    // }});

    this.dispatch(purchaseProducts());
  }
}

export const ecommerce = new Ecommerce();